import React from 'react'
import totallandarea from "../images/UNICORN AEROCITY_page-0001.jpg";
import landareapage from "../images/UNICORN AEROCITY.pdf";

function LandArea() {
  return (
    <div>
       
      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-2">
              <img src={totallandarea} className="card-img-top mb-2" alt="totallandarea" />
              <center>
                <a href={landareapage} target="_blank" rel="noopener noreferrer">
                <button className='download'>Download <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-down" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1z"/>
  <path fill-rule="evenodd" d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
</svg></button>
                </a>
              </center>
            </div>

          
          
          </div>
        </div>
      </div>
            <br />
    </div>
  )
}

export default LandArea